import Cookie from 'js-cookie';
import idx from 'idx';
import Rx from 'rxjs';

import { getTokenExpirationDate } from 'helpers';
import { API_URL, API_SECONDS_UNTIL_INVALID, JWT_TOKEN_KEY } from './constants';
import { authVerifyToken, logout } from './actions/auth';

let refreshObservable = null;

const logoutMessage =
	'Because of inactivity you have been logged out from the system, please log in again';

/**
 * Constant with cache expiration time in ms
 */
export const cacheExpiration = API_SECONDS_UNTIL_INVALID * 1000;

/**
 * Authenticated fetch
 *
 * Insert header for JWT bearer and try
 * to refresh an expired token on failed request
 *
 * @param string url
 * @param object options
 * @param string token
 * @param dispatch prop from Redux
 */
export function authFetch(url, options = {}, deprToken = '', dispatch) {
	const token = Cookie.get(JWT_TOKEN_KEY);

	options.headers = options.headers || {};
	options.headers.Authorization = `Bearer ${token}`;

	if (!options['Content-Type']) {
		options.headers['Content-Type'] = 'application/json';
	}

	const requestUrl = API_URL + url;

	return new Promise((resolve, reject) => {
		fetch(requestUrl, options)
			.then(res => {
				if (res.status === 401) {
					if (refreshObservable) {
						return refreshObservable.subscribe(async () => {
							const token = await Cookie.get(JWT_TOKEN_KEY);
							options.headers.Authorization = `Bearer ${token}`;
							fetch(requestUrl, options)
								.then(resolve)
								.catch(reject);
						});
					}

					refreshObservable = Rx.Observable.fromPromise(refreshToken(dispatch));

					refreshObservable.subscribe(async () => {
						const token = await Cookie.get(JWT_TOKEN_KEY);
						options.headers.Authorization = `Bearer ${token}`;
						fetch(requestUrl, options)
							.then(resolve)
							.catch(reject);
					});

					// Oh so swedish fulhack 💩
					// After 45000ms (45 sek), set refreshObservable to null
					return setTimeout(() => {
						refreshObservable = null;
					}, 45000);
				} else if (res.status === 403) {
					reject('Unauthorized.');
				} else if (res.ok) {
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(reject);
	});
}
export const authFetch2 = ({
	url,
	token = Cookie.get(JWT_TOKEN_KEY),
	dispatch,
	options,
}) =>
	new Promise((resolve, reject) =>
		authFetch(url, options, token, dispatch)
			.then(res => res.json())
			.then(res => {
				const error = idx(res, _ => _.error);
				return error ? reject(error) : resolve(res);
			})
			.catch(reject)
	);

export const uploadFile = ({ assets, url, token, dispatch }) => {
	const data = new FormData();
	Object.keys(assets).forEach(aKey => {
		data.append(aKey, assets[aKey]);
	});

	return authFetch2({
		url,
		token,
		dispatch,
		options: {
			method: 'post',
			'Content-Type': 'multipart/form-data',
			body: data,
		},
	});
};

/**
 * Refresh a token on token validation error
 *
 * On success, resolve with new token
 */ function refreshToken(dispatch) {
	const token = Cookie.get(JWT_TOKEN_KEY);

	return new Promise((resolve, reject) => {
		fetch(API_URL + 'token', {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res.json())
			.then(res => {
				if (!res.token) throw new Error('Could not refresh token');

				try {
					const expires = getTokenExpirationDate();

					dispatch(authVerifyToken(res.token));
					Cookie.set(JWT_TOKEN_KEY, res.token, {
						expires,
					});
					resolve(res.token);
				} catch (e) {
					throw new Error('Could not refresh token');
				}
			})
			.catch(e => {
				const currentPath = window.location.pathname;
				dispatch(logout(undefined, `/login?url=${currentPath}`));
			});
	});
} /**
 * File upload promise
 * @param string endpoint
 * @param file file
 * @param object context (containing token and dispatch)
 */
export function fileUploadPromise(endpoint, file, context) {
	const { token, dispatch } = context;

	return new Promise((resolve, reject) => {
		const data = new FormData();
		data.append('file', file);

		authFetch(
			endpoint,
			{
				method: 'post',
				'Content-Type': 'multipart/form-data',
				body: data,
			},
			token,
			dispatch
		)
			.then(res => res.json())
			.then(res => {
				if (!idx(res, _ => _.file)) {
					return idx(res, _ => _.error)
						? reject(res.error)
						: reject('Something went wrong.');
				}
				resolve(res.file);
			})
			.catch(reject);
	});
}



// WEBPACK FOOTER //
// ./src/api.js